import { render, staticRenderFns } from "./FloatingBalloon.vue?vue&type=template&id=50479f84&scoped=true"
import script from "./FloatingBalloon.vue?vue&type=script&lang=js"
export * from "./FloatingBalloon.vue?vue&type=script&lang=js"
import style0 from "./FloatingBalloon.vue?vue&type=style&index=0&id=50479f84&prod&lang=scss"
import style1 from "./FloatingBalloon.vue?vue&type=style&index=1&id=50479f84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50479f84",
  null
  
)

export default component.exports